import React from "react";
import logoSingapay from "../assets/images/logo-singapay.png";

const LandingPage = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#01793B] p-6 text-white">
      <div className="flex flex-col items-center max-w-sm w-full text-center space-y-10">
        
        {/* Logo Container - Putih bersih di atas background hijau */}
        <div className="bg-white p-6 rounded-[2.5rem] shadow-2xl">
          <img
            src={logoSingapay}
            alt="SingaPay"
            className="w-24 h-24 object-contain"
          />
        </div>

        {/* Tagline & Info */}
        <div className="space-y-4">
          <p className="text-2xl font-bold tracking-tight leading-tight">
            Seamless Features <br /> For Your Payments
          </p>
          <div className="h-1 w-12 bg-white/30 mx-auto rounded-full"></div>
          <p className="text-sm text-green-50/70 italic max-w-[250px] mx-auto">
            Solusi pembayaran digital aman, cepat, dan terpercaya.
          </p>
        </div>

        {/* Action Button - Putih Minimalis */}
        <div className="pt-4 w-full">
          <a
            href="https://singapay.co.id"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center w-full px-8 py-4 bg-white text-[#01793B] font-bold rounded-2xl hover:bg-green-50 transition-all duration-300 shadow-lg group"
          >
            Pelajari Selengkapnya
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              className="h-5 w-5 ml-2 transform group-hover:translate-x-1 transition-transform" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </a>
        </div>

        {/* Minimal Footer */}
        <footer className="pt-12 opacity-40">
          <p className="text-[10px] font-bold tracking-[0.3em] uppercase">
            &copy; {new Date().getFullYear()} SingaPay Indonesia
          </p>
        </footer>
      </div>
    </div>
  );
};

export default LandingPage;
